module.exports = __webpack_public_path__ + "static/media/download.85daa34b.svg";